import { create } from "zustand";
import { persist } from "zustand/middleware";

/** Cart store — holds lines locally; PRICING always comes from backend. */
export const useCart = create(persist(
  (set, get) => ({
    lines: [], // [{ product_id, sku, name, qty_cartons, kg_per_carton }]
    deliveryMode: "DELIVERY", // DELIVERY | PICKUP
    deliveryPointId: null,
    pickupRuleId: null,   // PICKUP: sede di ritiro scelta
    advancePayment: false,
    requestedDate: null,
    notes: "",
    add: (product, qty = 1) => set((s) => {
      const existing = s.lines.find((l) => l.product_id === product.id);
      const next = existing
        ? s.lines.map((l) => l.product_id === product.id ? { ...l, qty_cartons: l.qty_cartons + qty } : l)
        : [...s.lines, { product_id: product.id, sku: product.sku, name: product.name,
                         qty_cartons: qty, kg_per_carton: product.kg_per_carton }];
      return { lines: next };
    }),
    setQty: (product_id, qty) => set((s) => ({
      lines: s.lines.map((l) => l.product_id === product_id ? { ...l, qty_cartons: Math.max(1, qty) } : l),
    })),
    remove: (product_id) => set((s) => ({ lines: s.lines.filter((l) => l.product_id !== product_id) })),
    setMeta: (patch) => set((s) => ({ ...s, ...patch })),
    clear: () => set({ lines: [], notes: "", requestedDate: null, deliveryPointId: null, pickupRuleId: null, advancePayment: false, deliveryMode: "DELIVERY" }),
    replaceLines: (lines) => set({ lines }),
  }),
  { name: "b2b-cart-v1" }
));
